import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class SearchContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            products : [],
            loading : 1 ,
            search_word : '',
            search_category:''
        }
    }
 
    componentDidMount()
    {
        var data = { search_word : this.props.search_word, search_category : this.props.category} 
            axios.post(api_base_url+"search_products", data).then(response=>{
                this.setState({products:response.data}); 
                this.setState({search_word:this.props.search_word}); 
                this.setState({search_category:this.props.category}); 
                this.setState({loading:0});
            }); 
    }
    componentDidUpdate(prevProps)
    {
         var data = { search_word : this.props.search_word, search_category : this.props.category}

      
        if (this.props.search_word !== prevProps.search_word)
        {
            axios.post(api_base_url+"search_products", data).then(response=>{
                this.setState({products:response.data}); 
                this.setState({search_word:this.props.search_word}); 
                this.setState({search_category:this.props.category}); 
                this.setState({loading:0});
            });
        }
    }
 
      handleSearchWord= (event) => {
            var data = { search_word : this.state.search_word, search_category : this.props.category} 
            axios.post(api_base_url+"search_products", data).then(response=>{
                this.setState({products:response.data}); 
                this.setState({search_word:this.props.search_word}); 
                this.setState({loading:0});
            }); 
     }


      handleSearchWordChange= (event) => {
        this.setState({search_word:event.target.value});
     }


    render()
    {  var categories = JSON.parse(localStorage.getItem("categories"));
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    
             const { search_category, search_word } = this.state;
    const searchUrl = base_url+`search/${encodeURIComponent(search_category)}/${encodeURIComponent(search_word)}`;

    return (
        
           <div class="ul-inner-page-container">
                    <div class="ul-inner-products-wrapper">
                        <div class="row ul-bs-row flex-column-reverse flex-md-row">
                             
                            <div class="col-lg-3 col-md-4">
                                <div class="ul-products-sidebar">
                                     
                                    <div class="ul-products-sidebar-widget ul-products-search">
                                        <form action="#" class="ul-products-search-form">
                                            <input type="text" name="product-search"  onChange={this.handleSearchWordChange} value={this.state.search_word} id="ul-products-search-field" placeholder="Search Items" />
                                            <Link to={searchUrl} ><button onClick={this.handleSearchWord}><i class="flaticon-search-interface-symbol"></i></button></Link>
                                        </form>
                                    </div>
        
                                    {/****
                                    <div class="ul-products-sidebar-widget ul-products-price-filter">
                                        <h3 class="ul-products-sidebar-widget-title">Filter by price</h3>
                                        <form action="#" class="ul-products-price-filter-form">
                                            <div id="ul-products-price-filter-slider" data-price='1000'></div>
                                            <span class="filtered-price">$19 - $69</span>
                                        </form>
                                    </div>
         */} 
                                     
                                    <div class="ul-products-sidebar-widget ul-products-categories">
                                        <h3 class="ul-products-sidebar-widget-title">Categories</h3>
        
                                        <div class="ul-products-categories-link">
                                            {categories.map((item,key)=>( 
                                                <div>
                                                    <Link to={base_url+"category/"+item.slug} class={item.parent_id > 0 ? "dblock sub_cat": "dnone"}><span><i class="flaticon-arrow-point-to-right"></i> {item.name} </span></Link>
                                                    <Link to={base_url+"category/"+item.slug} class={item.parent_id > 0 ? "dnone": "dblock par_cat"}><span><i class="flaticon-arrow-point-to-right"></i> {item.name} </span></Link>
                                            </div>
                                            ))}
                                             
                                        </div>
                                    </div>
        
        
                                 
                                </div>
                            </div>
        
                             
                            <div class="col-lg-9 col-md-8">
                                <div class="row ul-bs-row row-cols-lg-3 row-cols-2 row-cols-xxs-1">
                                    
                                    {this.state.products.map((item,key)=>(
                                    <div class="col">
                                        <div class="ul-product">
                                         
        
                                            <div class="ul-product-img">
                                                 <img src={item.image} alt={item.title} />
        
                                                 {/**** <div class="ul-product-actions">
                                                            <button><i class="flaticon-shopping-bag"></i></button>
                                                            <Link  to="#"><i class="flaticon-hide"></i></Link>
                                                            <button><i class="flaticon-heart"></i></button>
                                                        </div> **/ }
        
                                                           <span class={item.discount > 0 ? "ul-product-discount-tag" : "ul-product-discount-tag dnone"}>{item.discount}% Off</span>   
                                                        </div>
        
                                            <div class="ul-product-txt">
                                                <h4 class="ul-product-title"><Link  to={base_url+"products/"+item.slug}>{item.title}</Link></h4>
                                   
                                            </div>
                 <div class="ul-product-heading">
                                                      
                                         <span class="ul-product-price">{item.price} {item.old_price != item.price && (<label>{item.old_price}</label>  )}</span>
                                         <Link  to={base_url+"products/"+item.slug}  class={item.quantity > 0 ? " add-button" : "dnone"}>Buy Now</Link>
                                          <label class={item.quantity > 0 ? " dnone" : "ostock"}>Out Of Stock</label>
                                         </div>
                                                                          
                                         
                                        </div>
                                    </div>
                                    ))}
         
                                </div>
           
                               {/** <div class="ul-pagination">
                                    <ul>
                                        <li><a href="#"><i class="flaticon-left-arrow"></i></a></li>
                                        <li class="pages">
                                            <a href="#" class="active">01</a>
                                            <a href="#">02</a>
                                            <a href="#">03</a>
                                            <a href="#">04</a>
                                            <a href="#">05</a>
                                        </li>
                                        <li><a href="#"><i class="flaticon-arrow-point-to-right"></i></a></li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
    );
}

}

export default SearchContent;